<template>
  <div class="col-sm-12 col-xl-12">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Colored breadcrumb</h3><span>use class <code>.breadcrumb-colored .bg-primary</code></span>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-4" v-for="item in ribbon" :key="item">
            <div class="card ribbon-wrapper">
              <div class="card-body">
                <div class="ribbon ribbon-primary ribbon-space-bottom">Ribbon</div>
                <p>{{ item.lorn }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-14 col-md-6 col-lg-4 text-start" v-for="item in ribbonItem" :key="item">
    <div class="ribbon-wrapper card">
      <div class="card-body">
        <div class="ribbon " :class="item.class">Ribbon</div>
        <p>{{ item.lorn }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import data from "@/data/ribbons.json"
export default {
  data() {
    return {
      ribbon: data.colored,
      ribbonItem: data.left
    }
  }
}
</script>